import { render, staticRenderFns } from "./EcommerceUserTable.vue?vue&type=template&id=2fab9e40&"
import script from "./EcommerceUserTable.vue?vue&type=script&lang=js&"
export * from "./EcommerceUserTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports